import { render } from "./Chat.vue?vue&type=template&id=c3573636&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=c3573636&scoped=true&lang=css"

import exportComponent from "E:\\项目\\5.0版本的老界面\\5.0版本的老界面\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3573636"]])

export default __exports__